// Package Imports
import { Component, OnInit } from '@angular/core';

// Services
import { AuthorizationService } from '../../services/authorization/authorization.service';

@Component({
  selector: 'app-member-portal-logout',
  templateUrl: './member-portal-logout.component.html',
  styleUrls: ['./member-portal-logout.component.css']
})
export class MemberPortalLogoutComponent implements OnInit {
  constructor(private readonly authService: AuthorizationService) { }

  ngOnInit() {
    this.authService.logout();
  }
}
